// userConnection.js
import { getDatabase, ref, set, onDisconnect, onValue, serverTimestamp } from 'firebase/database';
import { getFirestore, doc, setDoc, deleteDoc } from 'firebase/firestore';

export const setupUserConnection = async (user) => {
    if (!user) return;

    const rtdb = getDatabase();
    const firestore = getFirestore();

    const userStatusRef = ref(rtdb, `status/${user.uid}`);
    const connectedRef = ref(rtdb, '.info/connected');
    const userDocRef = doc(firestore, 'connectedUsers', user.uid);

    try {
        return onValue(connectedRef, async (snapshot) => {
            if (!snapshot.val()) return;

            try {
                const connectionInfo = {
                    userId: user.uid,
                    email: user.email,
                    role: user.role,
                    status: 'online',
                    lastSeen: serverTimestamp(),
                    timestamp: serverTimestamp()
                };

                // Set up disconnect handler first
                await onDisconnect(userStatusRef).set(null);

                // Then update both databases
                await Promise.all([
                    set(userStatusRef, connectionInfo),
                    setDoc(userDocRef, {
                        ...connectionInfo,
                        lastSeen: new Date(),
                        timestamp: new Date()
                    })
                ]);

            } catch (error) {
                console.warn('Error in connection setup:', error);
            }
        });
    } catch (error) {
        console.error('Error setting up connection tracking:', error);
    }
};

export const removeUserConnection = async (user) => {
    if (!user) return;

    const rtdb = getDatabase();
    const firestore = getFirestore();

    try {
        // First remove Firestore document
        const userDocRef = doc(firestore, 'connectedUsers', user.uid);
        await deleteDoc(userDocRef);

        // Then clean up RTDB
        const userStatusRef = ref(rtdb, `status/${user.uid}`);
        await set(userStatusRef, null);
    } catch (error) {
        // If it's just a permission error during logout, that's expected
        if (error.code !== 'permission-denied') {
            console.warn('Error in connection cleanup:', error);
        }
    }
};